export const getFilterData = (filter?: any, search?: string) => {
  if (!filter && !search) {
    return {};
  }

  const doctors = filter?.doctors?.map((id: string) => +id);

  return {
    ...(search && {
      start: {
        name: search
      }
    }),
    in: {
      createdBy_id: doctors
    }
  };
};
